import React from 'react';
import { useMutation } from '@tanstack/react-query';
import {
  ProfileWidget,
  RequestsWidget,
  VacationBalanceWidget,
  TimeOffWidget,
  AttendanceWidget,
  DocumentsWidget,
  OrganisationWidget,
  QuarterlyBonusWidget,
  TicketsWidget,
} from '../../components/Widgets';
import { getAuthUser, getImpersonateUsers } from '../../utils/auth.util';
import { ROLE_NAMES } from '../../common/constant';
import { ImpersonateTabs, SpinnerLoading } from '../../components/Common';
import { changeEmployee } from '../../store/apis/userService';

import './HRDashboard.scss';

function HRDashboard() {
  document.title = 'Dashboard | Envision Daikin';
  const roleName = getAuthUser()?.role?.Name;
  const isAdmin = roleName === ROLE_NAMES.ADMIN;
  const isHRAdmin = roleName === ROLE_NAMES.HR_ADMIN;
  const isAdminOrHRAdmin = isAdmin || isHRAdmin;

  const changeEmployeeMutation = useMutation({
    mutationFn: changeEmployee,
  });

  return (
    <div
      className="page-content"
      style={{
        paddingBottom: '0.5rem',
        marginTop: '-0.7rem',
        backgroundColor: '#EAECF0',
      }}
    >
      {getAuthUser()?.canViewOtherEmp && (
        <ImpersonateTabs
          users={getImpersonateUsers()}
          changeEmployeeMutation={changeEmployeeMutation}
        />
      )}
      <div className="hr-grid-container">
        {changeEmployeeMutation?.isPending ? (
          <SpinnerLoading spinnerSize="2rem" height="85vh" width="85vw" />
        ) : (
          <>
            <TicketsWidget admin={isAdminOrHRAdmin} />
            <RequestsWidget />
            <ProfileWidget />
            <QuarterlyBonusWidget />
            <VacationBalanceWidget />
            <AttendanceWidget />
            <TimeOffWidget />
            <DocumentsWidget />
            <OrganisationWidget />
          </>
        )}
      </div>
    </div>
  );
}

export default HRDashboard;
